import { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth';
import { isApiError } from '../lib/apiClient';
import { useSession } from '../lib/session';
import './AuthLayout.css';

export function LoginPage() {
  const token = useSession((s) => s.token);
  const signIn = useSession((s) => s.signIn);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (token) return <Navigate to={from} replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await authApi.login(email.trim().toLowerCase(), password);
      signIn(res.token, res.profile);
      navigate(from, { replace: true });
    } catch (err) {
      setError(isApiError(err) ? err.message : 'Could not sign in. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth__card card">
        <div className="auth__brand">
          <span className="auth__brand-mark">✦</span> FASD Assist
        </div>
        <h1>Provider sign in</h1>
        <p className="muted auth__sub">
          Use your Care Team account — the same login as the mobile app.
        </p>

        <form onSubmit={submit}>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <p className="error-text">{error}</p>}

          <button className="btn btn--block" type="submit" disabled={busy} style={{ marginTop: 8 }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="auth__foot">
          <Link to="/forgot-password">Forgot password?</Link>
          <span className="muted">
            No account? Register in the FASD Assist mobile app.
          </span>
        </div>
      </div>
    </div>
  );
}
